"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
var ZERO_WIDTH_SPACE = '\u200B';
exports.CardDeltaLabel = function (props) {
    var delta = props.comparisonDelta;
    if (delta === undefined) {
        return React.createElement("div", { style: comparisonStyle }, ZERO_WIDTH_SPACE);
    }
    var comparisonText = metrics_engine_1.formatComparisonTextForCard(delta, props.definition, props.formatString);
    var symbol = comparisonText.symbol || '';
    var direction = symbol !== '' ? (delta.absolute >= 0 ? '+' : '-') : '';
    return (React.createElement("div", { "data-tb-test-id": 'metric-comparison-text', style: comparisonStyle, role: 'img', "aria-label": direction + comparisonText.text }, symbol + comparisonText.text));
};
var comparisonStyle = {
    fontSize: '14px',
    color: '#333333',
    fontWeight: 'lighter',
};
//# sourceMappingURL=CardDeltaLabel.js.map